/**
 * Card — ID Visual V2 reusable card component
 */
import type { JSX } from 'preact';
import { T, CT } from '../../styles/tokens';

interface CardProps {
  children: any;
  onClick?: () => void;
  style?: JSX.CSSProperties;
  className?: string;
  highlight?: boolean;
  noPadding?: boolean;
  accent?: string;
}

export function Card({ children, onClick, style, className, highlight, noPadding, accent }: CardProps) {
  return (
    <div
      onClick={onClick}
      class={`v2-card ${highlight ? 'v2-card-highlight' : ''} ${className || ''}`}
      style={{
        position: 'relative',
        background: highlight
          ? `linear-gradient(135deg, T.primaryBg, ${T.accentBgSubtle})`
          : CT.card.bg,
        border: `1px solid ${highlight ? T.primaryBg : CT.card.border}`,
        borderRadius: CT.card.radius,
        padding: noPadding ? 0 : CT.card.padding,
        cursor: onClick ? 'pointer' : undefined,
        transition: `all ${T.transitionNormal}`,
        overflow: 'hidden',
        ...style,
      }}
    >
      {accent && (
        <div style={{
          position: 'absolute', top: 0, left: 0, right: 0, height: 3,
          background: accent, borderRadius: '14px 14px 0 0',
        }} />
      )}
      {children}
    </div>
  );
}

interface StatCardProps {
  label: string;
  value: string | number;
  sub?: string;
  accent?: string;
  icon?: any;
  onClick?: () => void;
  style?: JSX.CSSProperties;
}

export function StatCard({ label, value, sub, accent = 'var(--primary)', icon, onClick, style }: StatCardProps) {
  return (
    <Card onClick={onClick} style={style}>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14 }}>
        {icon && (
          <div style={{
            width: 42, height: 42, borderRadius: T.radiusLg,
            background: `${accent}15`,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: T.text2xl, flexShrink: 0,
          }}>{icon}</div>
        )}
        <div style={{ flex: 1 }}>
          <div style={{
            fontSize: T.textSm, fontWeight: T.weightSemibold, color: T.textMuted,
            marginBottom: T.space2, textTransform: 'uppercase', letterSpacing: '0.5px',
          }}>{label}</div>
          <div style={{
            fontSize: T.text4xl, fontWeight: 800, color: accent,
            letterSpacing: '-1px', lineHeight: 1,
          }}>{value}</div>
          {sub && <div style={{ fontSize: T.textSm, color: T.textMuted, marginTop: T.space1 }}>{sub}</div>}
        </div>
      </div>
    </Card>
  );
}
